import * as React from 'react'

function SvgTireMeshIcon(props) {
  return (
    <svg
      width={48}
      height={104}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <g clipPath="url(#TireMeshIcon_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48 76V63.414l.707-.707A1 1 0 0 0 48 61V48.414l.707-.707A1 1 0 0 0 48 46V33.414l.707-.707A1 1 0 0 0 48 31V18.414l.707-.707A1 1 0 0 0 48 16v-4c0-6.627-5.373-12-12-12H12C5.373 0 0 5.373 0 12v4a1 1 0 0 0-.707 1.707l.707.707V31a1 1 0 0 0-.707 1.707l.707.707V46a1 1 0 0 0-.707 1.707l.707.707V61a1 1 0 0 0-.707 1.707l.707.707V76a1 1 0 0 0-.707 1.707l.707.707V92c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12V78.414l.707-.707A1 1 0 0 0 48 76ZM36 2H12a9.974 9.974 0 0 0-7.36 3.23c.023.02.045.041.067.063l12 12a1 1 0 0 1-1.414 1.414L3.43 6.844A9.953 9.953 0 0 0 2 12v5.586l14.707 14.707a1 1 0 0 1-1.414 1.414L2 20.414v12.172l14.707 14.707a1 1 0 0 1-1.414 1.414L2 35.414v12.172l14.707 14.707a1 1 0 0 1-1.414 1.414L2 50.414v12.172l14.707 14.707a1 1 0 0 1-1.414 1.414L2 65.414v12.172l14.707 14.707a1 1 0 0 1-1.414 1.414L2 80.414V92c0 5.523 4.477 10 10 10h24c5.523 0 10-4.477 10-10V80.414L32.707 93.707a1 1 0 0 1-1.414-1.414L46 77.586V65.414L32.707 78.707a1 1 0 0 1-1.414-1.414L46 62.586V50.414L32.707 63.707a1 1 0 0 1-1.414-1.414L46 47.586V35.414L32.707 48.707a1 1 0 0 1-1.414-1.414L46 32.586V20.414L32.707 33.707a1 1 0 0 1-1.414-1.414L46 17.586V12c0-1.886-.522-3.65-1.43-5.156L32.707 18.707a1 1 0 0 1-1.414-1.414l12-12a1 1 0 0 1 .068-.062A9.974 9.974 0 0 0 36 2Z"
          fill="#000"
        />
      </g>
      <defs>
        <clipPath id="TireMeshIcon_svg__a">
          <path fill="#fff" d="M0 0h48v104H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgTireMeshIcon
